<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkFormValidation from "./BookmarkFormValidation.svelte";
  import BasicValidation from "./BasicValidation.svelte";
  import BrowserDefault from "./BrowserDefault.svelte";
  import TooltipValidation from "./TooltipValidation.svelte";
  import SupportedElements from "./SupportedElements.svelte";
</script>

<BookmarkFormValidation />
<Container fluid={true}>
  <Row>
    <Col sm="12">
        <BasicValidation />
        <BrowserDefault />
        <SupportedElements />
        <TooltipValidation />
    </Col>
  </Row>
</Container>
